import axios from 'axios';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { BsCheck } from 'react-icons/bs';
import { IoCloudUpload } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const UGC_ResourcesModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    let initialData = {
        FileTitle: '',
        FilePath: '',
    }
   
    const [fileUploading1, setFileUploading1] = useState(false);
    const [examBodyData, setExamBodyData] = useState(initialData);
    const fileRef = useRef(null);

    console.log(examBodyData);
    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            console.log(item)
            if (item.Sn > 0) {
                setExamBodyData({ FilePath: item.FilePath, FileTitle: item.FileTitle, Sn: item.Sn })
            }
            setModalBox(true);

        }
    }));

    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.FileTitle.trim().length === 0) {
                toast.error("Please Enter file title")
                return;
            } else if (examBodyData.FilePath.trim().length === 0) {
                toast.error("Please upload file first")
                return;
            }
            const response = axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/ugc/createResourse' : `/ugc/updateResourse`}`, examBodyData);
            console.log(response)
            toast.success(response.data.message);
            props.setDownloadsLoading(!props.loadDownloads);

        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setDownloadsLoading(!props.loadDownloads);
            setExamBodyData(initialData)
            setModalBox(false);
            setExamBodyData(initialData);
        }

    }
    const selectedFileHandler = async (file) => {
        try {
            setFileUploading1(true);
            const formData = new FormData();
            formData.append('uploadedFile', file, file.name);
            const response = await axios.post(BACKEND_SERVER_URL + '/uploadFile', formData);
            setExamBodyData({ ...examBodyData, FilePath: response.data.imagePath });
        } catch (error) {
            console.log(error);
            toast.error("Error while uploading file")
        } finally {
            fileRef.current.value = null;
            setTimeout(() => {
                setFileUploading1(false);
            }, 1000);

        }

    }



    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update File" : "Upload File"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="inputAcademicYear" className="form-label text-primary">File Title<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="text" name="" id="inputAcademicYear" value={examBodyData.FileTitle} onChange={(e) => setExamBodyData({ ...examBodyData, FileTitle: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="file1" className="form-label text-primary d-block">Upload File<span className="required">*</span></label>
                            <div className="d-flex align-items-center">
                                <label htmlFor="file1" className="w-75 d-flex align-items-center" style={{ background: "#f0f0f0", padding: 10, borderRadius: 6, cursor: "pointer" }}>
                                    <IoCloudUpload className="text-danger me-2" size={23} /> Upload File
                                </label>
                                <div className="ms-3">
                                    {fileUploading1 ? <Spinner variant="info" size="lg" /> : examBodyData.FilePath && <BsCheck color="green" size={40} />}
                                </div>
                            </div>
                            <input ref={fileRef} type="file" id="file1" style={{ display: "none" }} accept=".pdf" onChange={e => selectedFileHandler(e.target.files[0])} />
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Upload "}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default UGC_ResourcesModal;